import React from 'react';
import { LegacyChatTombstone } from '../../features/assistant/LegacyChatTombstone';

export const DocsAssistant: React.FC = () => {
  return (
    <div className="flex min-h-[calc(100vh-88px)] items-center justify-center p-6">
      <LegacyChatTombstone
        className="w-full max-w-xl"
        title="Docs Assistant has moved"
        description="Use the page-aware Assistant to ask about documentation from anywhere."
      />
    </div>
  );
};
